export const CASE_COMPACT_SAVINGS = 40;
export const CASE_COMPACT_SLACK = 16;

export type CaseMeterSpace = {
  availableHeight: number;
  neededHeight: number;
  compact: boolean;
};

export function shouldCompactCaseMeters(input: CaseMeterSpace): boolean {
  if (input.availableHeight <= 0) return input.compact;
  if (input.availableHeight < input.neededHeight) return true;
  if (!input.compact) return false;
  return input.availableHeight < input.neededHeight + CASE_COMPACT_SAVINGS + CASE_COMPACT_SLACK;
}

export function measureHandZone(zone: Element): Omit<CaseMeterSpace, "compact"> | null {
  if (!(zone instanceof HTMLElement)) return null;
  const stack = zone.querySelector(".hand-stack");
  if (!(stack instanceof HTMLElement)) return null;
  return { availableHeight: zone.clientHeight, neededHeight: stack.scrollHeight };
}
